/* ==========================================================================
   Koolseed — Ortak JS katmanı
   Paylaşılan yardımcılar + her sayfada gereken küçük davranışlar.
   Modül yok, global tek isim alanı: window.KS
   ========================================================================== */

(function () {
  'use strict';

  const FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', 'details > summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const KS = {
    /** Bir konteynerde odağı hapseder; kapatma fonksiyonu döner. */
    trapFocus(container, initial) {
      const focusables = () =>
        Array.from(container.querySelectorAll(FOCUSABLE)).filter(
          (el) => el.offsetParent !== null || el === document.activeElement
        );

      const onKeydown = (e) => {
        if (e.key !== 'Tab') return;
        const items = focusables();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      document.addEventListener('keydown', onKeydown);
      (initial || focusables()[0] || container).focus({ preventScroll: true });

      return () => document.removeEventListener('keydown', onKeydown);
    },

    /** Gövde kaydırmasını kilitler. Birden fazla panel açılabildiği için sayaçlı. */
    lockScroll: (function () {
      let depth = 0;
      let savedY = 0;
      return function (lock) {
        if (lock) {
          if (depth === 0) {
            savedY = window.scrollY;
            document.body.style.top = `-${savedY}px`;
            document.body.classList.add('ks-locked');
          }
          depth += 1;
        } else {
          depth = Math.max(0, depth - 1);
          if (depth === 0) {
            document.body.classList.remove('ks-locked');
            document.body.style.top = '';
            window.scrollTo(0, savedY);
          }
        }
      };
    })(),

    /** Ekran okuyucuya duyuru yapar. */
    announce(message) {
      const region = document.getElementById('ks-live-region');
      if (!region) return;
      region.textContent = '';
      // Aynı metin tekrar okunsun diye bir tick bekle.
      window.setTimeout(() => { region.textContent = message; }, 60);
    },

    /** Kısa süreli bildirim balonu. */
    toast(message, variant) {
      const el = document.getElementById('ks-toast');
      if (!el) return;
      el.textContent = message;
      el.dataset.variant = variant || 'info';
      el.hidden = false;
      el.classList.add('is-visible');
      window.clearTimeout(el._timer);
      el._timer = window.setTimeout(() => {
        el.classList.remove('is-visible');
        window.setTimeout(() => { el.hidden = true; }, 300);
      }, 3200);
      KS.announce(message);
    },

    /** Para birimini mağaza formatında yazar. */
    formatMoney(cents) {
      const format = window.KS_MONEY_FORMAT || '{{amount_with_comma_separator}} TL';
      const value = (cents / 100).toFixed(2);
      const [int, dec] = value.split('.');
      const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return format
        .replace('{{amount_with_comma_separator}}', `${grouped},${dec}`)
        .replace('{{amount_no_decimals_with_comma_separator}}', grouped)
        .replace('{{amount}}', `${grouped}.${dec}`)
        .replace('{{amount_no_decimals}}', grouped);
    },

    debounce(fn, wait) {
      let timer;
      return function (...args) {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => fn.apply(this, args), wait);
      };
    },

    /** Bir HTML metninden tek bir seçiciyi çeker. */
    extract(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
  };

  window.KS = KS;

  /* ---- Kaydırdıkça beliren bölümler ------------------------------------ */

  /* .ks-reveal sayfa yükünde opacity: 0 ile başlıyor ve görünür alana
     girdiğinde açılıyor. Bu gözlem yalnızca ilk yüklemede kurulursa, tema
     düzenleyicide bir bölüm yeniden basıldığında yeni düğümler kimse
     tarafından gözlemlenmiyor ve bölüm ekranda hiç belirmiyor — yer kaplıyor
     ama boş görünüyor. Bu yüzden gözlemci burada dışarıdan çağrılabilir. */
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('ks-is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
      )
    : null;

  function watchReveals(scope) {
    const nodes = (scope || document).querySelectorAll('.ks-reveal');
    nodes.forEach((el) => {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('ks-is-visible');
    });
  }

  KS.watchReveals = watchReveals;
  watchReveals(document);

  // Düzenleyicide bölüm yeniden basıldığında beklemeden göster: kullanıcı
  // zaten o bölüme bakıyor, beliriş animasyonunu tekrar oynatmaya gerek yok.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.ks-reveal').forEach((el) => el.classList.add('ks-is-visible'));
  });

  /* ---- Adet girişi ------------------------------------------------------ */

  class KsQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input) return;
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button) return;
      event.preventDefault();

      const step = button.name === 'plus' ? 1 : -1;
      const min = Number(this.input.min || 0);
      const max = this.input.max ? Number(this.input.max) : Infinity;
      const next = Math.min(max, Math.max(min, Number(this.input.value) + step));

      if (next === Number(this.input.value)) return;
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (!customElements.get('ks-quantity')) customElements.define('ks-quantity', KsQuantity);

  /* ---- Bildirim balonu elementi ----------------------------------------- */

  class KsToast extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'status');
      this.setAttribute('aria-live', 'polite');
    }
  }
  if (!customElements.get('ks-toast')) customElements.define('ks-toast', KsToast);
})();

/* Foto duvarı yatay şerit okları — bir kart genişliği kadar kaydırır. */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wall-prev], [data-wall-next]');
  if (!btn) return;
  const section = btn.closest('.ks-wall');
  const track = section && section.querySelector('[data-wall-track]');
  if (!track) return;
  const first = track.firstElementChild;
  const step = first ? first.getBoundingClientRect().width + 16 : 280;
  track.scrollBy({ left: btn.hasAttribute('data-wall-prev') ? -step : step, behavior: 'smooth' });
});
